import React from "react";
import Form from "./common/form";
import {
  getSystemIDfromHandle,
  getSystem,
  setSystemSuspend,
  findSystemBySerialNumber,
  setSystemSignals,
  initSystemUpdate,
  getSystemInfo,
} from "../services/systemService";
import { masterCompany } from "../config.json";
import BackGroundRectangle from "../components/backgroundRect";
import { toast } from "react-toastify";

class SystemSuspend extends Form {
  state = {
    systemSN: "",
  };

  async componentDidMount() {}
  handleSN = (e) => {
    const systemSN = e.currentTarget.value;
    this.setState({ systemSN });
  };

  sleep(milliseconds) {
    const date = Date.now();
    let currentDate = null;
    do {
      currentDate = Date.now();
    } while (currentDate - date < milliseconds);
  }

  handleSetSuspend = async (e) => {
    e.preventDefault();
    console.log("System Gateway Serial Number:", this.state.systemSN);

    const systemId = (await findSystemBySerialNumber(this.state.systemSN)).data
      .data.system_id;
    console.log("system ID:", systemId);
    const handleID = (await getSystem(systemId)).data.data[0].systemID.id;
    console.log("Handle ID", handleID);
    await setSystemSignals(systemId, "90", "TBD", "0", "0", "0");
    await initSystemUpdate(handleID);
    let systemInfo = await getSystemInfo(handleID);
    let systemStatus = systemInfo.data.data.status;
    let whileLoopCntr = 0;
    console.log("System Status:", systemStatus);
    while (systemStatus === "UPDATING" && whileLoopCntr < 20) {
      this.sleep(1000);
      systemInfo = await getSystemInfo(handleID);
      systemStatus = systemInfo.data.data.status;
      whileLoopCntr++;
    }
    if (whileLoopCntr > 20) toast.error("System Suspension FAILED!");
    else {
      toast.error("Waiting to Suspend the System...");
      this.sleep(30000); //Added wait time for 4G tp get a chance to stop sending systemStatus of ALIVE to the server
      await setSystemSuspend(handleID);
      toast.warning("This system was suspended!");
      let systemInfo = await getSystemInfo(handleID);
      let systemStatus = systemInfo.data.data.status;
      console.log("System Status After Suspension:", systemStatus);
      this.props.history.goBack();
    }
  };

  render() {
    return (
      <React.Fragment>
        <div
          style={{
            width: "350px",
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            marginTop: "150px",
            marginBottom: "150px",
            zIndex: 1,
          }}
        >
          <p className="basicParagraph">
            You are about to suspend a system's operation:
          </p>
          <p className="basicParagraph" style={{ color: "red" }}>
            Caution: This operation could ONLY be performed by an Admin at{" "}
            {masterCompany}.
          </p>
          <label className="basicParagraph" htmlFor="">
            Specify the Serial number for the system's SimplGateway:
          </label>
          <input
            className="form-control2"
            style={{
              marginLeft: "80px",
              width: "150px",
              marginTop: "20px",
            }}
            value={this.state.systemSN}
            onChange={this.handleSN}
            id="productSN"
            type="text"
          />
          <button
            className="btn btn-danger btn-sm"
            style={{
              marginLeft: "100px",
              marginTop: "30px",
            }}
            onClick={this.handleSetSuspend}
          >
            Suspend System
          </button>
        </div>
      </React.Fragment>
    );
  }
}

export default SystemSuspend;
